var map = {
	"./DesignOptions": 71,
	"./DesignOptions.css": 227,
	"./DesignOptions.js": 71,
	"./ExportPdf": 72,
	"./ExportPdf.js": 72,
	"./FileInput": 70,
	"./FileInput.css": 139,
	"./FileInput.js": 70,
	"./Footer": 73,
	"./Footer.css": 228,
	"./Footer.js": 73,
	"./Header": 74,
	"./Header.css": 229,
	"./Header.js": 74,
	"./Preview": 75,
	"./Preview.css": 78,
	"./Preview.js": 75,
	"./font/Scaramella-Brush.otf": 532,
	"./font/Scaramella-Regular.otf": 533,
	"./font/SourceHanSerifTC-SemiBold.otf": 534,
	"./font/SourceHanSerifTC-SemiBold.woff": 535,
	"./font/SourceHanSerifTC-SemiBold.woff2": 536,
	"./image/Spinner-1s-200px.gif": 114,
	"./image/card (1).pdf": 537,
	"./image/card (2).pdf": 538,
	"./image/card (3).pdf": 539,
	"./image/card.pdf": 540,
	"./image/copyPaste_example.png": 115,
	"./image/excel_example.png": 116,
	"./image/folder-upload.svg": 117,
	"./image/grayBackground.png": 133,
	"./image/image0.jpg": 118,
	"./image/image1.jpg": 134,
	"./image/image10-example.jpg": 123,
	"./image/image10.jpg": 541,
	"./image/image11-example.jpg": 124,
	"./image/image11.jpg": 542,
	"./image/image12-example.jpg": 125,
	"./image/image12.jpg": 543,
	"./image/image13-example.jpg": 126,
	"./image/image13.jpg": 544,
	"./image/image14-example.jpg": 127,
	"./image/image14.jpg": 545,
	"./image/image15-example.jpg": 128,
	"./image/image15.jpg": 546,
	"./image/image16-example.jpg": 129,
	"./image/image16.jpg": 547,
	"./image/image17-example.jpg": 226,
	"./image/image17.jpg": 548,
	"./image/image18-example.jpg": 130,
	"./image/image18.jpg": 549,
	"./image/image19-example.jpg": 131,
	"./image/image19.jpg": 550,
	"./image/image5-example.jpg": 119,
	"./image/image5.jpg": 551,
	"./image/image6-example.jpg": 120,
	"./image/image6.jpg": 552,
	"./image/image7-example.jpg": 121,
	"./image/image7.jpg": 553,
	"./image/image8.jpg": 554,
	"./image/image9-example.jpg": 122,
	"./image/image9.jpg": 555,
	"./image/pinkBackground.png": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;